import React from 'react'
import {FormatNumber} from "../../helpers/Helpers";
import Card from "@material-ui/core/Card";
import GenerateDuplicateInvoice from "../invoices/GenerateDuplicateInvoice";
import PseIcon from '../../assets/pse.png'
import Tooltip from "@material-ui/core/Tooltip";
import Session from "../../helpers/Session";

class PaymentCurrent extends React.Component {

    render() {

        const {data} = this.props;
        const userData = Session.getLogin();

        return (
            <Card>
                <table className='custom-table'>
                    <thead>
                    <tr>
                        <th colSpan={7}>Factura actual</th>
                    </tr>
                    <tr>
                        <th>Cuenta NIU</th>
                        <th>Nro. Factura</th>
                        <th>Fecha Vencimiento</th>
                        <th>Periodos Vencidos</th>
                        <th>Total a pagar ($)</th>
                        <th colSpan={2}>Acción</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr key={1}>
                        <td>{data.cuentaCodigo}</td>
                        <td>{data.cuentaFactura}</td>
                        <td>{data.FECHA_VENCIMIENTO}</td>
                        <td>{data.PERIODOS_VENCIDOS}</td>
                        <td>$ {FormatNumber.new(data.DEUDA_TOTAL)}</td>
                        <td valign="top">
                            <GenerateDuplicateInvoice account={data}/>
                        </td>
                        <td>
                            {
                                data.DEUDA_TOTAL > 0 ?
                                    <Tooltip
                                        title="Pagar en línea">
                                        <a target='_blank'
                                           href={`https://pagos.electrohuila.com.co/Default?cta=${data.cuentaCodigo}&terceroMail=${userData.terceroMail}&terceroTel=${userData.terceroCel}`}
                                           rel="noopener noreferrer">
                                            <img style={{width: '45px'}} src={PseIcon} alt='icon pse'/>
                                        </a>
                                    </Tooltip>
                                    : null
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Card>
        );
    }
}

export default PaymentCurrent
